import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { StartupService } from '../../../services/startup.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  standalone: true,
  imports: [ReactiveFormsModule],
})
export class ForgotPasswordComponent {
  form: FormGroup;
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private startupService: StartupService,
    private sharedService: SharedService,
    public modalRef: BsModalRef
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  submit() {
    if (this.form.invalid) return;
    this.isSubmitting = true;
    const email = this.form.get('email')?.value;

    this.startupService.forgotPassword(email).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        this.sharedService.raiseSuccessToast(res.message);
        this.modalRef.hide();
      },
      error: (err) => {
        this.isSubmitting = false;
        this.sharedService.raiseErrorToast(err.error?.message || 'Failed to send reset email');
      }
    });
  }
}
